// only used on list and detail pages for dialogs
const VideoDialog4i = function () {
	let videoBtns, videoPlayer, videoOptions, theVideoDialog, videoHTML, azureMediaPlayerPath, azureMediaPlayerSkinPath,
    	init = function () {
    		videoHTML = '<video id="azuremediaplayer" class="azuremediaplayer amp-flush-skin amp-big-play-centered embed-responsive-item" width="100%" height="100%" tabindex="0" controls>' + '</video>';
    		azureMediaPlayerPath = '//amp.azure.net/libs/amp/2.3.11/azuremediaplayer.min.js';
    		azureMediaPlayerSkinPath = '//amp.azure.net/libs/amp/2.3.11/skins/amp-flush/azuremediaplayer.min.css';
    		videoBtns = [].slice.call(document.querySelectorAll(".videoLink"));
    		videoPlayer = "";
    		videoOptions = {
            		autoplay: true,
            		controls: true,
            		logo: { enabled: false },
            		techOrder: ["azureHtml5JS", "flashSS", "html5FairPlayHLS", "silverlightSS", "html5"]
    		};
    		if (videoBtns.length){
    			theVideoDialog = new Dialog4i();

	    		const vidHTML =
	            		'<a href="#" class="transcriptLink inlineMiddle marginBtm10 text16 darkestLink">View Transcript</a>' +
	           		'<div id="videoContainer" class="dialogContent borderTopMdGray videoContent marginBtm15">' +
	            			'<div class="spinner" role="alert" aria-busy="true" aria-atomic="true" aria-label="Loading video, please wait">' +
	            				'<div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div>' +
	            			'</div>' +
	            		'</div>';
	            		
	    		theVideoDialog.Init({
	            		triggerElements: videoBtns,
	            		dialogClass: "videoDialog",
	           		title: "Loading Product Video",
	            		content: vidHTML,
	            		onOpen: getVideo,
	            		update: updateContent
	    		});
    		}
    	},
    	setUpVideo = function (el) {
    		let triggerEl = el,
            	videoID = triggerEl.getAttribute("data-videoid"),
            	productID = triggerEl.getAttribute("data-productid"),
            	productAlias = triggerEl.hasAttribute("data-productalias") ? triggerEl.getAttribute("data-productalias") : "",
            	productName = triggerEl.hasAttribute("aria-label") ? triggerEl.getAttribute("aria-label") : "";
    		if (productName == "" && triggerEl.querySelector("svg")) productName = triggerEl.querySelector("svg").getAttribute("aria-label");

    		let controllerUrl = "/video/";
    		if (productID == null && videoID != null)
            		controllerUrl += "VideoDetailsByID/" + videoID;
    		else if (videoID == null && productID != null)
            		controllerUrl += "VideoDetails/" + productID;
    		else controllerUrl += "VideoDetailsByVideoAndProductId/" + videoID + "/" + productID;

    		fetch(controllerUrl, {
            		method: 'GET',
            		headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch' }
    		}).then(function (response) {
            		return (response.ok) ? response.json() : []; // response.json() returns a promise
    		}).then(function (response) {
            		// only for dialogs
            		//if (isDialog) updateContent(productName, productAlias, response.wv.VideoTitle, productID, response.wv.PublishedUrl, response.videos);
            		updateContent(productName, productAlias, response.wv.VideoTitle, productID, response.wv.PublishedUrl, response.videos);

			if (typeof amp == 'function') initPlayer(response.wv.PublishedUrl, response.wv.EnglishSubtitleUrl);
            		else loadScript(initPlayer, response.wv.PublishedUrl, response.wv.EnglishSubtitleUrl);
    		}).catch(function (error) {
            		// place error handling here
    		});
    	},
    	disposePlayer = function () {
    		if (videoPlayer != "") videoPlayer.dispose();
    	},
    	getVideo = function (element) {
    		let triggerEl = element;
    		setUpVideo(triggerEl);
    	},
   	initPlayer = function (playVidUrl, playVidCaptionUrl) {
   	 	disposePlayer();
   		if (document.getElementById("videoContainer")) document.getElementById("videoContainer").innerHTML = videoHTML;

    		videoPlayer = amp("azuremediaplayer", videoOptions);
    		if (playVidCaptionUrl !== null) {
            		videoPlayer.src(
            			[{ src: playVidUrl }],
            			[{ src: playVidCaptionUrl, srclang: "en", kind: "subtitles", label: "English" }]
            		);
    		} else {
            		videoPlayer.src([{ src: playVidUrl }]);
    		}
    	},
    	loadScript = function (callback, videoUrl, subtitleUrl) {
    		const head = document.head;
    		const link = document.createElement('link');
    		link.href = azureMediaPlayerSkinPath;
    		link.type = 'text/css';
    		link.rel = 'stylesheet';
    		head.appendChild(link);

    		const script = document.createElement('script');
    		script.type = 'text/javascript';
    		script.src = azureMediaPlayerPath;
    		script.onload = (function () { callback(videoUrl, subtitleUrl); });
    		head.appendChild(script);
    	},
    	bindNewLinks = function () {
    		let vidLinks = [].slice.call(document.querySelectorAll(".videoLink"));
    		if (vidLinks.length) theVideoDialog.BindTriggerElements(vidLinks);
    	},
    	updateContent = function (productName, productAlias, vidTitle, prodID, videoLink, moreVids) {
    		if (productName != "") document.querySelector(".videoDialog").querySelector("h2").textContent = productName;
    		if (vidTitle != null && vidTitle.toLowerCase() == "mug imprints") document.querySelector('.videoDialog').querySelector("h2").textContent = "Video for Mug Imprint Options";

    		showTranscriptLink(productAlias, vidTitle);

    		if (document.querySelector(".otherVidContainer")) document.querySelector(".otherVidContainer").remove();

    		if (moreVids != null && moreVids.length > 1) {
            		var otherVideoLinks = '<div class="otherVidContainer displayFlex flexSpaceBetween flexAlignItemsCenter">';
            		for (let i = 0; i < moreVids.length; i++) {
                		if (moreVids[i].PublishedUrl != videoLink) {
                			if (moreVids[i].PublishedUrl != videoLink) {
                        			otherVideoLinks += '<button play-video class="videoLink btnToHyp pointer text16 underline padding10"' +
                        				'" data-productid="' + prodID + '" data-videoid="' + moreVids[i].VideoID +
                        				'" data-productalias="' + productAlias + '" aria-label="' + productName + '">';
                        			if (moreVids[i].VideoTitle != null && moreVids[i].VideoTitle.toLowerCase() == "mug imprints")
                        				otherVideoLinks += 'Watch video about imprint options on mugs.</button>';
                        			else otherVideoLinks += 'Watch ' + productName + '.</button>';
                			}
                		}
            		}
            		otherVideoLinks += '</div>';
            		document.getElementById("videoContainer").insertAdjacentHTML('afterend', otherVideoLinks);
		}
    		addEvents();
	},
   	showTranscriptLink = function (vidProdAlias, vidProdTitle) {
    		if (vidProdTitle != null && vidProdTitle.toLowerCase() == "mug imprints")
            		document.querySelector(".transcriptLink").setAttribute("href", "/video#mugimprints"); // go to video product page
    		else if (vidProdAlias !== "")
            		document.querySelector(".transcriptLink").setAttribute("href", "/video/product/" + vidProdAlias + "#transcript"); // go to video product page
    		else document.querySelector(".transcriptLink").classList.add("hide");
    	},
    	openNewVideo = function (e) {
    		e.preventDefault();
    		let element = e.currentTarget;
    		getVideo(element);
    	},
    	addEvents = function () {
    		if (document.querySelector(".otherVidContainer") != null) {
            		let otherVidLinks = [].slice.call(document.querySelector(".otherVidContainer").querySelectorAll(".videoLink"));
            		for (let x = 0; x < otherVidLinks.length; x++) {
                		otherVidLinks[x].removeEventListener("click", openNewVideo);
                		otherVidLinks[x].addEventListener("click", openNewVideo);
            		}
    		}
    	};

	return {
    		Init: init,
    		BindNewLinks: bindNewLinks
	};
};

let videoJS4i; //global for use in list page javascript when paging link is clicked
(function(){
	videoJS4i = new VideoDialog4i();
	videoJS4i.Init();
})();